import { LIST_TYPES } from "../utils/listTypes";

import ScrollList from "./ScrollList";

const MedicalStatusDashFilter = ({ medicalStatusData }) => {
  return (
    <div
      id="Medical-Status-Dashboard-Filter"
      data_testid="Medical-Status-Dashboard-Filter"
      className="overflow-y-auto"
    >
      <ScrollList array={medicalStatusData} type={LIST_TYPES.BUTTON_LIST} />
    </div>
  );
};

export default MedicalStatusDashFilter;
